import { register } from '@antv/x6-vue-shape';
import { Graph } from '@antv/x6';

import BuilderGraph from './graph';
import nodeRegistry from './node-registry';

export default class Builder {
  #context;
  #app;
  #graphs = {};

  constructor(ctx) {
    this.#context = ctx;
    this.#app = ctx.app;
    this.#registerNodes();
  }

  makeGraph(containerElement, settings) {
    const graph = new BuilderGraph(this.#context, containerElement, settings);
    this.#graphs[graph.graphId] = graph;

    return graph;
  }

  getGraph(graphId, conversationId) {
    // Get graph by graphId
    if (graphId && this.#graphs[graphId]) {
      return this.#graphs[graphId];
    }

    // Find graph by conversationId, otherwise return first graph in list
    if (conversationId) {
      const convGraph = Object.values(this.#graphs).find((graph) => graph.conversationId === conversationId);

      if (convGraph) {
        return convGraph;
      }
    }

    return this.#graphs[Object.keys(this.#graphs)[0]];
  }

  #registerNodes() {
    Object.values(nodeRegistry).forEach((node) => {
      register({
        ...node,
        component: {
          ...(node.component || {}),
          data: (...props) => {
            return {
              ...(node.component?.data?.(...props) || {}),
              context: this.#app,
            };
          },
        },
      });
    });

    Graph.registerEdge(
      'edge',
      {
        zIndex: -1,
        attrs: {
          line: {
            fill: 'none',
            strokeLinejoin: 'round',
            strokeWidth: 2,
            stroke: '#8E8D8B',
            sourceMarker: {
              name: 'circle',
              r: 10,
              strokeWidth: 2,
              stroke: '#E8E7E5',
              fill: '#8E8D8B',
            },
            targetMarker: {
              name: 'block',
              width: 12,
              height: 20,
              open: true,
              strokeWidth: 2,
              stroke: '#8E8D8B',
            },
          },
        },
      },
      true
    );
  }
}
